module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";
	fox.registerWidget('Login_Forgot_Switcher', {
		configure: function(options) {
			this.registerOptions('', {
				template: 'div.form-container.common-content',
				widgets: {
					login: {
						widget: 'MCP_Login_Wizard',
						
						// group: 'authForm',
						// autoRender: true,
						// container: '.form-container',
						// template: 'login_form',
						// handleDom: {
							// switchForgotPass: {
								// target: '#change-form-forgot',
								// event: 'click',
								// callback: '@parent:switchToForgot'
							// }
						// }
					},

					// forgotPass: {
					// 	widget: 'PassRecovery_Form',
					// 	active: false,
					// 	group: 'authForm',
					// 	autoRender: true,
					// 	container: '.form-container',
					// 	template: 'forgot_form',
					// 	handleDom: {
					// 		switchLogin: {
					// 			target: '#change-form-login',
					// 			event: 'click',
					// 			callback: '@parent:switchToLogin'
					// 		}
					// 	}
					// }
				}
			});

			this.callParent('configure', arguments);
		},

		switchToForgot: function() {
			this.switchEmbeddedWidget('forgotPass');
		},

		switchToLogin: function() {
			this.switchEmbeddedWidget('login');
		},

		deactivate: function() {
			this.callParent('deactivate', arguments);
			this.switchEmbeddedWidget('login');
		}


	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/login/switcher.js
// module id = 197
// module chunks = 5